export default __webpack_public_path__ + "static/media/about-carousel-6-water-kiss.be69af51.jpg";